/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FleetListDevicesBalenaDevicesQueryResponse, FleetListDevicesBalenaDevices401, FleetListDevicesBalenaDevices403 } from "../models/FleetListDevicesBalenaDevices";

export function getFleetListDevicesBalenaDevicesUrl() {
  const res = { method: 'GET', url: `/fleet/v1/balena-devices` as const }
  return res
}

/**
 * @description Superadmin receives all devices; client admins receive devices tagged with their client slug (`customer` tag).
 * Requires CLIENT_ADMIN role or client API key
 * @summary List Balena devices
 * {@link /fleet/v1/balena-devices}
 */
export async function fleetListDevicesBalenaDevices(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FleetListDevicesBalenaDevicesQueryResponse, ResponseErrorConfig<FleetListDevicesBalenaDevices401 | FleetListDevicesBalenaDevices403>, unknown>({ method : "GET", url : getFleetListDevicesBalenaDevicesUrl().url.toString(), ... requestConfig })
  return res.data
}